import React from "react";
import { TrendingUp, Clock, PoundSterling, Users } from "lucide-react";

const studies = [
  {
    company: "Greenfield Gas & Heating",
    trade: "Gas Engineer · Surrey",
    metric: "+£3,200 / mo",
    icon: PoundSterling,
    points: [
      "AI receptionist captures out-of-hours boiler call-outs",
      "Average response time dropped from 6 hrs to 90 seconds",
      "32% of new bookings now come in after 7pm",
    ],
    accent: "bg-[var(--pink)]",
  },
  {
    company: "Pip's Mobile Hair Studio",
    trade: "Hairdresser · Manchester",
    metric: "−12 hrs admin / wk",
    icon: Clock,
    points: [
      "WhatsApp bot books appointments straight into Google Calendar",
      "Auto-sends colour patch test reminders & post-care advice",
      "No more late-night reply marathons",
    ],
    accent: "bg-[var(--blue)]",
  },
  {
    company: "Bright Spark Electrical",
    trade: "Electrician · Leeds",
    metric: "+218% leads",
    icon: TrendingUp,
    points: [
      "Lead-capture quiz on website pre-qualifies EV charger jobs",
      "AI sends written quotes within 4 minutes",
      "Won 3 new contracts in month one",
    ],
    accent: "bg-[var(--yellow)] text-ink",
  },
  {
    company: "Sweep Clean Co.",
    trade: "Domestic Cleaning · Bristol",
    metric: "0 missed calls",
    icon: Users,
    points: [
      "Voice agent answers every enquiry, even mid-job",
      "Routes urgent move-out cleans to the next available slot",
      "Repeat customer rate up 41%",
    ],
    accent: "bg-white text-ink",
  },
];

export const CaseStudies = () => {
  return (
    <section
      id="case-studies"
      data-testid="case-studies-section"
      className="border-b-2 border-ink py-24 lg:py-32 bg-[var(--ink)] text-white relative"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="uppercase text-sm font-bold tracking-[0.25em] text-[var(--yellow)]">
              Real results
            </p>
            <h2 className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">
              UK trades, <span className="text-[var(--pink)]">winning</span>{" "}
              their time back.
            </h2>
          </div>
          <p className="max-w-md text-stone-300 text-lg">
            A few of the small businesses we've quietly made bigger. Numbers
            verified, names changed where requested.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {studies.map((c, i) => {
            const Icon = c.icon;
            const lightText = c.accent.includes("text-ink");
            return (
              <div
                key={c.company}
                data-testid={`case-study-${i}`}
                className={`relative border-2 border-ink rounded-3xl p-7 shadow-brutal ${c.accent} ${lightText ? "text-ink" : "text-white"}`}
              >
                <div className="flex items-center justify-between">
                  <div
                    className={`h-12 w-12 rounded-xl border-2 border-ink flex items-center justify-center ${lightText ? "bg-white" : "bg-white text-ink"}`}
                  >
                    <Icon size={22} />
                  </div>
                  <p className="font-display text-3xl sm:text-4xl font-black">
                    {c.metric}
                  </p>
                </div>
                <h3 className="font-display mt-6 text-2xl font-extrabold">
                  {c.company}
                </h3>
                <p
                  className={`text-sm font-semibold ${lightText ? "text-stone-700" : "text-white/80"}`}
                >
                  {c.trade}
                </p>
                <ul className="mt-5 space-y-2">
                  {c.points.map((p) => (
                    <li
                      key={p}
                      className={`flex gap-2 items-start ${lightText ? "text-stone-800" : "text-white/95"}`}
                    >
                      <span className="mt-1 inline-block h-2 w-2 rounded-full bg-current shrink-0" />
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
